import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sub-nav',
  templateUrl: './sub-nav.component.html',
  styleUrls: ['./sub-nav.component.scss']
})
export class SubNavComponent implements OnInit {

    constructor(public common: CommonService, private _router: Router) { }

    @Input()
    Menu: any = [];

    @Input()
    Module: any = {}

    ngOnInit(): void {
        
    }

    changeSubmenu(item: any) {
        this._router.navigate([item.navigateURL]);
        //this.setActiveMenu(item.menuCode);
    }

    public setActiveMenu(menuCode: any) {

        for (var i = 0; i < this.Menu.length; i++) {
            if (this.Menu[i].menuCode === menuCode) {
                this.Menu[i].isActiveMenu = true;
            }
            else
                this.Menu[i].isActiveMenu = false;
        }
    }
}
